import api from './api';
import type { PageResponse, ProductItem } from '../types';

export interface ProductQuery {
  search?: string;
  serviceId?: string;
  page?: number;
  size?: number;
}

export const productService = {
  getProducts: async ({ search, serviceId, page, size }: ProductQuery): Promise<PageResponse<ProductItem>> => {
    const searchParams: Record<string, string | number> = {};
    if (search !== undefined && search !== '') searchParams.search = search;
    if (serviceId !== undefined && serviceId !== '') searchParams.serviceId = serviceId;
    if (page !== undefined) searchParams.page = page;
    if (size !== undefined) searchParams.size = size;
    return api.get('products', { searchParams }).json<PageResponse<ProductItem>>();
  },

  getProduct: async (id: string): Promise<ProductItem> => {
    return api.get(`products/${id}`).json<ProductItem>();
  },
};
